export const WORK_FETCHING = 'WORK_FETCHING';
export const WORK_FETCHED_SUCCESS = 'WORK_FETCHED_SUCCESS';
export const THEME_FETCHED_SUCCESS = 'THEME_FETCHED_SUCCESS';



// WEBPACK FOOTER //
// ./src/constants/constants.js